var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"salut container"},[_c('h5',[_vm._v("Salut")]),_vm._v(" value : "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }